import React from 'react';
import Modal from '@mui/material/Modal';
import { IconX } from '@tabler/icons-react';
import { THINGS_TO_KNOW_TIPS } from './thingsToKnowTips';

interface ThingsToKnowModalProps {
  open: boolean;
  onClose: () => void;
}

const ThingsToKnowModal: React.FC<ThingsToKnowModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="things-to-know-title">
      <div className="fixed inset-0 flex justify-center items-center p-4">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full max-h-[85vh] overflow-y-auto">
          <div className="flex items-start justify-between gap-4">
            <h2
              id="things-to-know-title"
              className="text-xl font-semibold text-neutral-800"
            >
              Things to know
            </h2>
            <button type="button" aria-label="Close" onClick={onClose}>
              <IconX size={22} />
            </button>
          </div>
          <ul className="mt-4 flex flex-col gap-4">
            {THINGS_TO_KNOW_TIPS.map(tip => (
              <li key={tip.title}>
                <h3 className="font-semibold text-neutral-800">{tip.title}</h3>
                <p className="text-sm text-neutral-600 mt-1">{tip.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default ThingsToKnowModal;
